<gm-loading-spinner *ngIf="loading"></gm-loading-spinner>
<dialog-draggable-header>{{this.isNew ? 'Add' : 'Update'}} Tool Change</dialog-draggable-header>
<div mat-dialog-content>
   <form class="flex-dialog-container" [formGroup]="editToolChangeForm">
      <div class="space-between-items mb-2">
         <mat-form-field>
            <mat-label>NEC LEC</mat-label>
            <div
               [matTooltip]="getNecLecInformation()" matTooltipClass="test">
               <input #neclec matInput formControlName="necLec" autocomplete="off" [minLength]="NEC_LEC_MIN_LENGTH"
                  (input)="neclec.value = $event.target.value.toUpperCase()" [maxLength]="NEC_LEC_MAX_LENGTH"
                  [value]="neclec.value.toUpperCase()"  (keyup.enter)="isNecLecValid(neclec.value)" (blur)="isNecLecValid(neclec.value)"/>
            </div>
               <mat-error *ngIf="this.editToolChangeForm.get('necLec').hasError('pattern')">
                  The only valid entries for the NEC LEC are REL, (REL) or 2 letters (i.e. A, AA, B, BA, etc...)
               </mat-error>
         </mat-form-field>
      </div>

      <div class="space-between-items">
         <div
         [matTooltip]="getToolAffectedInformation()" matTooltipClass="test">
            <mat-checkbox color="primary" formControlName="toolAffected">Is Tool Affected?</mat-checkbox>
         </div>
      </div>

      <div class="space-between-items">
         <div
         [matTooltip]="getCertDataAffectedInformation()" matTooltipClass="test">
            <mat-checkbox color="primary" formControlName="certDataAffected">Is Certification Data Affected?
            </mat-checkbox>
         </div>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>Tool Lead Release Level</mat-label>
            <div [matTooltip]="getTlLeadRelLvlInformation()" matTooltipClass="test">
               <input #tlr matInput formControlName="tlLeadRelLvl" autocomplete="off"  (keyup.enter)="enableDisableShippedtoDateBank($event)" (blur)="enableDisableShippedtoDateBank($event)"
                  [value]="tlr.value.toString().toUpperCase()" />
            </div>
         </mat-form-field>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>Shipped to Databank Date</mat-label>
            <div
               matTooltip='Shipped to Databank Date - Can be entered after entering TL Lead Rel Lvl and Design Source.'>
               <input #dtShippedToDatabank matInput [matDatepicker]="picker" formControlName="dtShippedToDatabank"
                  (dateInput)="disableEnableFormField(necComplDate, $event)" />
            </div>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
         </mat-form-field>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>NEC Completion Date</mat-label>
            <div
               matTooltip='Notification Engineer Change Complete Date - Can be entered after entering the Shipped to Databank Date'>
               <input #necComplDate matInput [matDatepicker]="pickerNec" formControlName="necCompleteDate" />
            </div>
            <mat-datepicker-toggle matSuffix [for]="pickerNec"></mat-datepicker-toggle>
            <mat-datepicker #pickerNec></mat-datepicker>
         </mat-form-field>
      </div>

      <div class="space-between-items">
         <mat-form-field>
            <mat-label>Design Source</mat-label>
            <div matTooltip='Design Source - Required before entering the Shipped to Databank Date'>
               <mat-select formControlName="designSourceId" (selectionChange)="enableDisableShippedtoDateBank($event)">
                  <mat-option *ngFor="let ds of designSources" [value]="ds.id">
                     {{ds.sourceName}}
                  </mat-option>
               </mat-select>
            </div>
         </mat-form-field>
      </div>

   </form>

</div>
<div mat-dialog-actions class="mat-dialog-actions-end no-margin">
   <button mat-raised-button color="primary" (click)="onUpdateClick()" (keypress.enter)="onUpdateClick()"
      [disabled]=" loading || editToolChangeForm.invalid">{{this.isNew ? 'Save' : 'Update'}}</button>
   <button mat-raised-button mat-dialog-close (click)="onCancelClick()" (keypress.enter)="onCancelClick()"
      cdkFocusInitial [disabled]="loading">Cancel</button>
</div>